/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { AddressLineRepairResponseDTOFromJSON, BuyerEmailImportRequestToJSON, BuyerEmailImportResponseFromJSON, ExtensionOrderStatusBatchRequestToJSON, ExtensionOrderStatusBatchResponseFromJSON, ExtensionProfitPreviewDTOFromJSON, ImportOrdersFromExtensionRequestToJSON, ImportOrdersFromExtensionResponseFromJSON, OpenBuyerOrdersResponseFromJSON, OrderBuyerOrderIdUpdateRequestDTOToJSON, OrderExportResponseDTOFromJSON, OrderFlagAssignRequestDTOToJSON, OrderListRequestDTOToJSON, OrderNoteUpdateRequestDTOToJSON, OrderProfitabilityDTOFromJSON, OrderProfitabilityUpdateRequestDTOToJSON, OrderResponseDTOFromJSON, OrderSearchResultDTOFromJSON, OrderTrackingCountsDTOFromJSON, OrderTrackingListRequestDTOToJSON, PaginatedResponseOrderResponseDTOFromJSON, PaginatedResponseOrderTrackingItemDTOFromJSON, RecordBuyerOrderFromExtensionRequestToJSON, SupplierDeliveryImportRequestToJSON, SupplierDeliveryImportResponseFromJSON, TrackingCheckResultDTOFromJSON, } from '../models/index';
/**
 *
 */
export class OrderControllerApi extends runtime.BaseAPI {
    /**
     */
    async assignOrderFlagRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling assignOrderFlag().');
        }
        if (requestParameters['amazonOrderId'] == null) {
            throw new runtime.RequiredError('amazonOrderId', 'Required parameter "amazonOrderId" was null or undefined when calling assignOrderFlag().');
        }
        if (requestParameters['orderFlagAssignRequestDTO'] == null) {
            throw new runtime.RequiredError('orderFlagAssignRequestDTO', 'Required parameter "orderFlagAssignRequestDTO" was null or undefined when calling assignOrderFlag().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/{marketplace}/{amazonOrderId}/flag`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        urlPath = urlPath.replace(`{${"amazonOrderId"}}`, encodeURIComponent(String(requestParameters['amazonOrderId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: OrderFlagAssignRequestDTOToJSON(requestParameters['orderFlagAssignRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => OrderResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async assignOrderFlag(requestParameters, initOverrides) {
        const response = await this.assignOrderFlagRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async checkOrderTrackingRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling checkOrderTracking().');
        }
        if (requestParameters['amazonOrderId'] == null) {
            throw new runtime.RequiredError('amazonOrderId', 'Required parameter "amazonOrderId" was null or undefined when calling checkOrderTracking().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/{marketplace}/{amazonOrderId}/tracking-check`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        urlPath = urlPath.replace(`{${"amazonOrderId"}}`, encodeURIComponent(String(requestParameters['amazonOrderId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => TrackingCheckResultDTOFromJSON(jsonValue));
    }
    /**
     */
    async checkOrderTracking(requestParameters, initOverrides) {
        const response = await this.checkOrderTrackingRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async countOrderTrackingQuickFiltersRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/tracking/counts`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderTrackingListRequestDTOToJSON(requestParameters['orderTrackingListRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => OrderTrackingCountsDTOFromJSON(jsonValue));
    }
    /**
     */
    async countOrderTrackingQuickFilters(requestParameters = {}, initOverrides) {
        const response = await this.countOrderTrackingQuickFiltersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async exportOrderTrackingRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/tracking/export`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderTrackingListRequestDTOToJSON(requestParameters['orderTrackingListRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => OrderExportResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async exportOrderTracking(requestParameters = {}, initOverrides) {
        const response = await this.exportOrderTrackingRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async exportOrdersRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling exportOrders().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/{marketplace}/export`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderListRequestDTOToJSON(requestParameters['orderListRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => OrderExportResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async exportOrders(requestParameters, initOverrides) {
        const response = await this.exportOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getOrderRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling getOrder().');
        }
        if (requestParameters['amazonOrderId'] == null) {
            throw new runtime.RequiredError('amazonOrderId', 'Required parameter "amazonOrderId" was null or undefined when calling getOrder().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/{marketplace}/{amazonOrderId}`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        urlPath = urlPath.replace(`{${"amazonOrderId"}}`, encodeURIComponent(String(requestParameters['amazonOrderId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => OrderResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async getOrder(requestParameters, initOverrides) {
        const response = await this.getOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async importBuyerDeliveriesFromExtensionRaw(requestParameters, initOverrides) {
        if (requestParameters['supplierDeliveryImportRequest'] == null) {
            throw new runtime.RequiredError('supplierDeliveryImportRequest', 'Required parameter "supplierDeliveryImportRequest" was null or undefined when calling importBuyerDeliveriesFromExtension().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/extension/buyer-deliveries`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupplierDeliveryImportRequestToJSON(requestParameters['supplierDeliveryImportRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierDeliveryImportResponseFromJSON(jsonValue));
    }
    /**
     */
    async importBuyerDeliveriesFromExtension(requestParameters, initOverrides) {
        const response = await this.importBuyerDeliveriesFromExtensionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async importBuyerEmailsFromExtensionRaw(requestParameters, initOverrides) {
        if (requestParameters['buyerEmailImportRequest'] == null) {
            throw new runtime.RequiredError('buyerEmailImportRequest', 'Required parameter "buyerEmailImportRequest" was null or undefined when calling importBuyerEmailsFromExtension().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/buyer-emails`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BuyerEmailImportRequestToJSON(requestParameters['buyerEmailImportRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BuyerEmailImportResponseFromJSON(jsonValue));
    }
    /**
     */
    async importBuyerEmailsFromExtension(requestParameters, initOverrides) {
        const response = await this.importBuyerEmailsFromExtensionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async importFromExtensionRaw(requestParameters, initOverrides) {
        if (requestParameters['importOrdersFromExtensionRequest'] == null) {
            throw new runtime.RequiredError('importOrdersFromExtensionRequest', 'Required parameter "importOrdersFromExtensionRequest" was null or undefined when calling importFromExtension().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/importFromExtension`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ImportOrdersFromExtensionRequestToJSON(requestParameters['importOrdersFromExtensionRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ImportOrdersFromExtensionResponseFromJSON(jsonValue));
    }
    /**
     */
    async importFromExtension(requestParameters, initOverrides) {
        const response = await this.importFromExtensionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async listOpenBuyerOrdersForExtensionRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/extension/open-buyer-orders`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => OpenBuyerOrdersResponseFromJSON(jsonValue));
    }
    /**
     */
    async listOpenBuyerOrdersForExtension(initOverrides) {
        const response = await this.listOpenBuyerOrdersForExtensionRaw(initOverrides);
        return await response.value();
    }
    /**
     */
    async listOrderTrackingRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/tracking`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderTrackingListRequestDTOToJSON(requestParameters['orderTrackingListRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseOrderTrackingItemDTOFromJSON(jsonValue));
    }
    /**
     */
    async listOrderTracking(requestParameters = {}, initOverrides) {
        const response = await this.listOrderTrackingRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async listOrdersRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling listOrders().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/{marketplace}/list`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderListRequestDTOToJSON(requestParameters['orderListRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResponseOrderResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async listOrders(requestParameters, initOverrides) {
        const response = await this.listOrdersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async orderStatusBatchForExtensionRaw(requestParameters, initOverrides) {
        if (requestParameters['extensionOrderStatusBatchRequest'] == null) {
            throw new runtime.RequiredError('extensionOrderStatusBatchRequest', 'Required parameter "extensionOrderStatusBatchRequest" was null or undefined when calling orderStatusBatchForExtension().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/extension/status-batch`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExtensionOrderStatusBatchRequestToJSON(requestParameters['extensionOrderStatusBatchRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ExtensionOrderStatusBatchResponseFromJSON(jsonValue));
    }
    /**
     */
    async orderStatusBatchForExtension(requestParameters, initOverrides) {
        const response = await this.orderStatusBatchForExtensionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async previewProfitForExtensionRaw(requestParameters, initOverrides) {
        if (requestParameters['externalOrderId'] == null) {
            throw new runtime.RequiredError('externalOrderId', 'Required parameter "externalOrderId" was null or undefined when calling previewProfitForExtension().');
        }
        const queryParameters = {};
        if (requestParameters['externalOrderId'] != null) {
            queryParameters['externalOrderId'] = requestParameters['externalOrderId'];
        }
        if (requestParameters['productCostUsd'] != null) {
            queryParameters['productCostUsd'] = requestParameters['productCostUsd'];
        }
        if (requestParameters['giftCardUsd'] != null) {
            queryParameters['giftCardUsd'] = requestParameters['giftCardUsd'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/extension/profit-preview`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => ExtensionProfitPreviewDTOFromJSON(jsonValue));
    }
    /**
     */
    async previewProfitForExtension(requestParameters, initOverrides) {
        const response = await this.previewProfitForExtensionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async recordBuyerOrderFromExtensionRaw(requestParameters, initOverrides) {
        if (requestParameters['recordBuyerOrderFromExtensionRequest'] == null) {
            throw new runtime.RequiredError('recordBuyerOrderFromExtensionRequest', 'Required parameter "recordBuyerOrderFromExtensionRequest" was null or undefined when calling recordBuyerOrderFromExtension().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/recordBuyerOrderFromExtension`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RecordBuyerOrderFromExtensionRequestToJSON(requestParameters['recordBuyerOrderFromExtensionRequest']),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async recordBuyerOrderFromExtension(requestParameters, initOverrides) {
        await this.recordBuyerOrderFromExtensionRaw(requestParameters, initOverrides);
    }
    /**
     */
    async repairAddressLinesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters['dryRun'] != null) {
            queryParameters['dryRun'] = requestParameters['dryRun'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/admin/repair-address-lines`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => AddressLineRepairResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async repairAddressLines(requestParameters = {}, initOverrides) {
        const response = await this.repairAddressLinesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async searchOrdersAcrossMarketplacesRaw(requestParameters, initOverrides) {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError('q', 'Required parameter "q" was null or undefined when calling searchOrdersAcrossMarketplaces().');
        }
        const queryParameters = {};
        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }
        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/search`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrderSearchResultDTOFromJSON));
    }
    /**
     */
    async searchOrdersAcrossMarketplaces(requestParameters, initOverrides) {
        const response = await this.searchOrdersAcrossMarketplacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateBuyerOrderIdRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling updateBuyerOrderId().');
        }
        if (requestParameters['amazonOrderId'] == null) {
            throw new runtime.RequiredError('amazonOrderId', 'Required parameter "amazonOrderId" was null or undefined when calling updateBuyerOrderId().');
        }
        if (requestParameters['orderBuyerOrderIdUpdateRequestDTO'] == null) {
            throw new runtime.RequiredError('orderBuyerOrderIdUpdateRequestDTO', 'Required parameter "orderBuyerOrderIdUpdateRequestDTO" was null or undefined when calling updateBuyerOrderId().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/{marketplace}/{amazonOrderId}/buyer-order-id`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        urlPath = urlPath.replace(`{${"amazonOrderId"}}`, encodeURIComponent(String(requestParameters['amazonOrderId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: OrderBuyerOrderIdUpdateRequestDTOToJSON(requestParameters['orderBuyerOrderIdUpdateRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => OrderResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async updateBuyerOrderId(requestParameters, initOverrides) {
        const response = await this.updateBuyerOrderIdRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateOrderNoteRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling updateOrderNote().');
        }
        if (requestParameters['amazonOrderId'] == null) {
            throw new runtime.RequiredError('amazonOrderId', 'Required parameter "amazonOrderId" was null or undefined when calling updateOrderNote().');
        }
        if (requestParameters['orderNoteUpdateRequestDTO'] == null) {
            throw new runtime.RequiredError('orderNoteUpdateRequestDTO', 'Required parameter "orderNoteUpdateRequestDTO" was null or undefined when calling updateOrderNote().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/{marketplace}/{amazonOrderId}/note`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        urlPath = urlPath.replace(`{${"amazonOrderId"}}`, encodeURIComponent(String(requestParameters['amazonOrderId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: OrderNoteUpdateRequestDTOToJSON(requestParameters['orderNoteUpdateRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => OrderResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async updateOrderNote(requestParameters, initOverrides) {
        const response = await this.updateOrderNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updateProfitabilityRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling updateProfitability().');
        }
        if (requestParameters['amazonOrderId'] == null) {
            throw new runtime.RequiredError('amazonOrderId', 'Required parameter "amazonOrderId" was null or undefined when calling updateProfitability().');
        }
        if (requestParameters['orderProfitabilityUpdateRequestDTO'] == null) {
            throw new runtime.RequiredError('orderProfitabilityUpdateRequestDTO', 'Required parameter "orderProfitabilityUpdateRequestDTO" was null or undefined when calling updateProfitability().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/orders/{marketplace}/{amazonOrderId}/profitability`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        urlPath = urlPath.replace(`{${"amazonOrderId"}}`, encodeURIComponent(String(requestParameters['amazonOrderId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: OrderProfitabilityUpdateRequestDTOToJSON(requestParameters['orderProfitabilityUpdateRequestDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => OrderProfitabilityDTOFromJSON(jsonValue));
    }
    /**
     */
    async updateProfitability(requestParameters, initOverrides) {
        const response = await this.updateProfitabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const AssignOrderFlagMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const CheckOrderTrackingMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const ExportOrdersMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const GetOrderMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const ListOrdersMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const UpdateBuyerOrderIdMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const UpdateOrderNoteMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const UpdateProfitabilityMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
